import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; 

const firebaseConfig = {
apiKey: "AIzaSyAOXgECuXn6-w7vkgwZc84yn9TKoCL4qng",
  authDomain: "hergiftsco-6e2ce.firebaseapp.com",
  projectId: "hergiftsco-6e2ce",
  storageBucket: "hergiftsco-6e2ce.firebasestorage.app",
  messagingSenderId: "658083339766",
  appId: "1:658083339766:web:d4c00346ebf36e2e943bd7",
  measurementId: "G-C1VW3T8N7Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app); 

export { db, auth, storage, analytics };
